// Tutorial: https://egghead.io/lessons/vue-js-create-a-vuex-store-using-typescript

import {
  TeamLessonsScores,
  Team,
  TeamEngagement,
  TeamPerformance,
  User,
  UserStat,
  TeamLesson,
  UserMeta,
  TeamCompletion,
  TeamLeaderboard,
  TeamActivity,
  UserPlan,
  Review,
  Rubric,
  RubricSessionAnswers,
  SessionFeedback,
  LearnerReviews,
  RubricAnswers,
  RubricAnswersByUser,
  TeamReviewSettings,
  LearnerTeam,
  AvailablePlan,
} from "@/types.ts";
import { MyLessons, NewLesson } from "@/types/MyLessons";
import { LearnerRecordings } from "@/types/LearnerRecordings";
import { License } from "@/types";
export interface State {
  UID: string;
  JWT: string;
  doneInitAssessment: boolean;
  teamLessonsScores: TeamLessonsScores[];
  myLessons: NewLesson[] | null;
  learnerRecordings?: LearnerRecordings;
  learnerTeams?: LearnerTeam[];
  currentLearnerTeam: LearnerTeam | null;
  teams?: Team[];
  teamEngagement?: TeamEngagement | null;
  teamCompletion?: TeamCompletion | null;
  teamLeaderboard?: TeamLeaderboard | null;
  teamPerformanceOverall?: TeamPerformance | null;
  teamPerformancePace?: TeamPerformance | null;
  teamPerformanceConciseness?: TeamPerformance | null;
  teamPerformanceFillers?: TeamPerformance | null;
  currentTeamUsers?: User[];
  currentTeam: Team | null;
  currentTeamStats: UserStat[];
  currentTeamActivity: TeamActivity[];
  teamLessons: TeamLesson[];
  userMeta: UserMeta | null;
  userPlan: UserPlan | null;
  userLicenseList: License[] | [];
  userPlanLoading: boolean;
  availablePlansLoading: boolean;
  availablePlans: AvailablePlan[];
  recordedVideoURL: string | null;
  sessionReviewRequired: Review[];
  sessionAlreadyReviewed: Review[];
  transcriptStartIndex: number;
  transcriptEndIndex: number;
  reviewCommentSelectedIndex: number;
  reviewCommentPlay: number;
  newReviewCommentVisible: boolean;
  rubricData: Rubric | null;
  rubricSessionAnswers: RubricSessionAnswers[] | null;
  rubricSessionAnswersByUser: RubricAnswersByUser[] | null;
  rubricSessionAverageAnswers: RubricAnswers[] | null;
  teamReviewSettings: TeamReviewSettings | null;
  sessionFeedback: SessionFeedback[] | null;
  learnerReviews: LearnerReviews[] | null;
  displayError: any | null;
}

export const state: State = getDefaultState();

export function getDefaultState(): State {
  return {
    teamLessonsScores: [],
    myLessons: null,
    learnerRecordings: undefined,
    UID: "",
    JWT: "",
    doneInitAssessment: false,
    learnerTeams: [],
    currentLearnerTeam: null,
    teams: [],
    teamEngagement: null,
    teamCompletion: null,
    teamLeaderboard: null,
    teamPerformanceOverall: null,
    teamPerformancePace: null,
    teamPerformanceConciseness: null,
    teamPerformanceFillers: null,
    currentTeamUsers: [],
    currentTeam: null,
    currentTeamStats: [],
    currentTeamActivity: [],
    teamLessons: [],
    userMeta: null,
    userPlan: null,
    userLicenseList: [],
    userPlanLoading: false,
    availablePlansLoading: false,
    availablePlans: [],
    recordedVideoURL: null,
    sessionReviewRequired: [],
    sessionAlreadyReviewed: [],
    transcriptStartIndex: -1,
    transcriptEndIndex: -1,
    reviewCommentSelectedIndex: -1,
    reviewCommentPlay: -1,
    newReviewCommentVisible: false,
    rubricData: null,
    rubricSessionAnswers: null,
    rubricSessionAnswersByUser: null,
    rubricSessionAverageAnswers: null,
    teamReviewSettings: null,
    sessionFeedback: null,
    learnerReviews: null,
    displayError: null,
  };
}
